import React, { Component } from "react";
import { Bar, Line } from "react-chartjs-2";

class BarGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labels: this.props.labels,
      data: this.props.data
    };
  }
  componentWillReceiveProps(newProps) {
    this.setState({
      ...this.state,
      labels: newProps.labels,
      data: newProps.data
    });
  }
  componentWillMount() {}

  style = {
    wrapper: {
      backgroundColor: "#029bb4",
      padding: "25px",
      display: "flex",
      justifyContent: "space-around",
      borderRadius: "10px"
    },
    yLabelWrapper: {
      flex: "1",
      color: "#fff",
      alignSelf: "center"
    },
    chartWrapper: {
      flex: "3"
    },
    filler: {
      flex: "1"
    }
  };
  render() {
    this.data = {
      labels: this.state.labels,
      datasets: [
        {
          label: "Analytics",
          backgroundColor: this.props.line ? "#00cec9aa" : "#000", 
          data: this.state.data
        }
      ]
    };
    this.options = {
      title: {
        display: true,
        text: this.props.title,
        fontColor: "#fff",
        fontSize: 16,
        fontFamily: "arial"
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: false,
              display: true,
              fontColor: "#fff"
            },
            gridLines: {
              display: true,
              zeroLineColor: "#fff",
              color: "#00b4cd"
            },
            scaleLabel: {
              display: false,
              labelString: this.props.yLabel,
              fontColor: "#fff",
              fontSize: 16,
              maxRotation: 0
            }
          }
        ],
        xAxes: [
          {
            gridLines: {
              display: true,
              zeroLineColor: "#fff",
              color: "#00B4CD"
            },
            ticks: {
              beginAtZero: false,
              display: true,
              fontColor: "#fff",
              autoSkip: true,
              maxTicksLimit: 12
            },
            scaleLabel: {
              display: true,
              labelString: this.props.xLabel,
              fontColor: "#fff",
              fontSize: 16
            }
          }
        ]
      },
      legend: {
        display: false
      }
    };

    return (
      <div style={{ ...this.style.wrapper, ...this.props.style }}>
        <div style={this.style.yLabelWrapper}>
          <p>{this.props.yLabel}</p>
        </div>{" "}
        <div style={this.style.chartWrapper}>
          {
            this.props.line ?
            <Line
              width={300}
              height={300}
              data={this.data}
              options={this.options}
            />
            :
            <Bar
              width={300}
              height={300}
              data={this.data}
              options={this.options}
            />
          }
        </div>
        <div style={this.style.filler} />
      </div>
    );
  }
}

export default BarGraph;
